import { render, staticRenderFns } from "./GlobalSearchResultsDropdown.vue?vue&type=template&id=400e8ae9"
import script from "./GlobalSearchResultsDropdown.vue?vue&type=script&lang=js"
export * from "./GlobalSearchResultsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports